import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { OrderBar } from './components/OrderBar';
import { HeroSection } from './components/HeroSection';
import { BannerSlider } from './components/BannerSlider';
import { MenuCategories } from './components/MenuCategories';
import { WhyVictory } from './components/WhyVictory';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { CartProvider } from './contexts/CartContext';
// Pages
import { AboutPage } from './pages/AboutPage';
import { CateringPage } from './pages/CateringPage';
import { ContactPage } from './pages/ContactPage';
import { MenuPage } from './pages/MenuPage';
import { MainDishesPage } from './pages/MainDishesPage';
import { DrinksPage } from './pages/DrinksPage';
import { SnacksPage } from './pages/SnacksPage';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { CartPage } from './pages/CartPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <CartProvider data-id="element-0">
      <div className="min-h-screen bg-cream flex flex-col font-body" data-id="element-1">
        <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-2" />

        <main className="flex-grow" data-id="element-3">
          <AnimatePresence mode="wait" data-id="element-4">
            {currentPage === 'home' && <div key="home" className="animate-in fade-in duration-500" data-id="element-5">
                <OrderBar data-id="element-6" />
                <HeroSection onNavigate={handleNavigate} data-id="element-7" />
                <MenuCategories onNavigate={handleNavigate} data-id="element-8" />
                <BannerSlider data-id="element-9" />
                <WhyVictory data-id="element-10" />
                <Testimonials data-id="element-11" />
              </div>}
            {currentPage === 'about' && <AboutPage key="about" onNavigate={handleNavigate} data-id="element-12" />}
            {currentPage === 'menu' && <MenuPage key="menu" onNavigate={handleNavigate} data-id="element-13" />}
            {currentPage === 'catering' && <CateringPage key="catering" onNavigate={handleNavigate} data-id="element-14" />}
            {currentPage === 'contact' && <ContactPage key="contact" onNavigate={handleNavigate} data-id="element-15" />}

            {currentPage === 'main-dishes' && <MainDishesPage key="main-dishes" onNavigate={handleNavigate} data-id="element-16" />}
            {currentPage === 'drinks' && <DrinksPage key="drinks" onNavigate={handleNavigate} data-id="element-17" />}
            {currentPage === 'snacks' && <SnacksPage key="snacks" onNavigate={handleNavigate} data-id="element-18" />}

            {currentPage === 'signin' && <SignInPage key="signin" onNavigate={handleNavigate} data-id="element-19" />}
            {currentPage === 'signup' && <SignUpPage key="signup" onNavigate={handleNavigate} data-id="element-20" />}
            {currentPage === 'cart' && <CartPage key="cart" onNavigate={handleNavigate} data-id="element-21" />}
          </AnimatePresence>
        </main>

        <Footer onNavigate={handleNavigate} data-id="element-22" />
      </div>
    </CartProvider>;
}